enum Currency {
    DOLLAR = "DOLLAR",
    CUP = "CUP",
    MLC = "MLC",
    EURO = "EURO"
}

export default Currency;